<template>
    <div style="margin-bottom: 15rem">
        <div class="box">
            <div class="top-bar">
                <b-button @click="$router.go(-1)" class="level-item" type="is-light">
                    <b-icon icon="arrow-left" pack="fas" />
                    <span>Back</span>
                </b-button>
                <p class="sub-title">{{ isEdit ? "Edit" : "New" }} {{ itemName }}</p>
            </div>
            <hr />
            <div class="form-entry-container">
                <form @submit.prevent="formSubmit">
                    <b-field label="ID">
                        <b-input disabled v-model="form.id" />
                    </b-field>

                    <b-field label="Form Name" :message="form.errors.get('name')" :type="{ 'is-danger': form.errors.has('name') }" expanded>
                        <b-input v-model="form.name" type="text" />
                    </b-field>

                    <div class="box">
                        <draggable v-model="entries" group="entries" v-if="entries.length" handle=".handle">
                            <div class="relative" v-for="(item, idx) in entries" :key="idx">
                                <div class="trash-btn" @click="removeItem(idx)"><b-icon icon="delete" type="is-danger"></b-icon></div>

                                <b-field>
                                    <template #label>
                                        <b-icon class="handle" icon="format-align-justify"></b-icon>
                                        Form Entry #{{ idx + 1 }}
                                    </template>
                                </b-field>
                                <b-field grouped>
                                    <b-radio-button
                                        v-model="item.input_type"
                                        native-value="text"
                                        type="is-primary is-light is-outlined"
                                        size="is-small"
                                    >
                                        <b-icon icon="form-textbox-password"></b-icon>
                                        <span>Text</span>
                                    </b-radio-button>
                                    <b-radio-button
                                        v-model="item.input_type"
                                        native-value="textarea"
                                        type="is-primary is-light is-outlined"
                                        size="is-small"
                                    >
                                        <b-icon icon="format-align-left"></b-icon>
                                        <span>Paragraph</span>
                                    </b-radio-button>
                                    <b-radio-button
                                        v-model="item.input_type"
                                        native-value="number"
                                        type="is-primary is-light is-outlined"
                                        size="is-small"
                                    >
                                        <b-icon icon="numeric"></b-icon>
                                        <span>Number</span>
                                    </b-radio-button>
                                    <b-radio-button
                                        v-model="item.input_type"
                                        native-value="email"
                                        type="is-primary is-light is-outlined"
                                        size="is-small"
                                    >
                                        <b-icon icon="at"></b-icon>
                                        <span>Email</span>
                                    </b-radio-button>
                                    <b-radio-button
                                        v-model="item.input_type"
                                        native-value="select"
                                        type="is-primary is-light is-outlined"
                                        size="is-small"
                                        @input="initList(item.data)"
                                    >
                                        <b-icon icon="form-dropdown"></b-icon>
                                        <span>List</span>
                                    </b-radio-button>
                                    <b-radio-button
                                        v-model="item.input_type"
                                        native-value="document"
                                        type="is-primary is-light is-outlined"
                                        size="is-small"
                                    >
                                        <b-icon icon="file-pdf-box"></b-icon>
                                        <span>Document</span>
                                    </b-radio-button>
                                    <b-radio-button
                                        v-model="item.input_type"
                                        native-value="image"
                                        type="is-primary is-light is-outlined"
                                        size="is-small"
                                    >
                                        <b-icon icon="file-image"></b-icon>
                                        <span>Image</span>
                                    </b-radio-button>
                                    <b-radio-button
                                        v-model="item.input_type"
                                        native-value="page_end"
                                        type="is-primary is-light is-outlined"
                                        size="is-small"
                                    >
                                        <b-icon icon="format-page-break"></b-icon>
                                        <span>Page Breaker</span>
                                    </b-radio-button>
                                </b-field>

                                <b-field grouped v-if="item.input_type !== 'page_end'">
                                    <b-field
                                        label="Title English"
                                        custom-class="is-small"
                                        expanded
                                        :message="form.errors.get(`entries.${idx}.name_en`)"
                                        :type="{ 'is-danger': form.errors.has(`entries.${idx}.name_en`) }"
                                    >
                                        <b-input v-model="item.name_en" size="is-small" />
                                    </b-field>
                                    <b-field
                                        label="Title Kurdish"
                                        custom-class="is-small"
                                        expanded
                                        :message="form.errors.get(`entries.${idx}.name_ku`)"
                                        :type="{ 'is-danger': form.errors.has(`entries.${idx}.name_ku`) }"
                                    >
                                        <b-input v-model="item.name_ku" size="is-small" />
                                    </b-field>
                                    <b-field
                                        label="Title Arabic"
                                        custom-class="is-small"
                                        expanded
                                        :message="form.errors.get(`entries.${idx}.name_ar`)"
                                        :type="{ 'is-danger': form.errors.has(`entries.${idx}.name_ar`) }"
                                    >
                                        <b-input v-model="item.name_ar" size="is-small" />
                                    </b-field>
                                </b-field>

                                <b-field grouped group-multiline v-if="['text', 'textarea', 'number'].indexOf(item.input_type) !== -1">
                                    <b-field
                                        label="Mimimum"
                                        custom-class="is-small"
                                        :message="form.errors.get(`entries.${idx}.data.min`)"
                                        :type="{ 'is-danger': form.errors.has(`entries.${idx}.data.min`) }"
                                    >
                                        <b-input v-model="item.data.min" placeholder="Minumum input" type="number" size="is-small" />
                                    </b-field>
                                    <b-field
                                        label="Maximum"
                                        custom-class="is-small"
                                        :message="form.errors.get(`entries.${idx}.data.max`)"
                                        :type="{ 'is-danger': form.errors.has(`entries.${idx}.data.max`) }"
                                    >
                                        <b-input v-model="item.data.max" placeholder="Maximum input" type="number" size="is-small" />
                                    </b-field>
                                </b-field>

                                <b-field grouped group-multiline v-if="['image', 'document'].indexOf(item.input_type) !== -1">
                                    <b-field
                                        label="Multiple Files (max: 4)"
                                        custom-class="is-small"
                                        :message="form.errors.get(`entries.${idx}.data.multiple`)"
                                        :type="{ 'is-danger': form.errors.has(`entries.${idx}.data.multiple`) }"
                                    >
                                        <b-switch v-model="item.data.multiple" size="is-small" true-value="1" false-value="0" />
                                    </b-field>
                                </b-field>

                                <div v-if="item.input_type === 'select'">
                                    <b-field
                                        v-for="(undefined, idv) in item.data.values"
                                        :key="idv"
                                        :label="`Option ${idv + 1}`"
                                        custom-class="is-small"
                                        horizontal
                                        expanded
                                        :message="form.errors.get(`entries.${idx}.data.values.${idv}`)"
                                        :type="{ 'is-danger': form.errors.has(`entries.${idx}.data.values.${idv}`) }"
                                    >
                                        <b-input v-model="item.data.values[idv]" placeholder="Option" type="text" size="is-small" expanded />
                                        <div>
                                            <p class="controls">
                                                <b-button
                                                    @click="item.data.values.splice(idv, 1)"
                                                    size="is-small"
                                                    v-if="idv + 1 != item.data.values.length"
                                                >
                                                    <b-icon icon="delete" type="is-danger" size="is-small" />
                                                </b-button>
                                                <b-button
                                                    @click="item.data.values.push('')"
                                                    size="is-small"
                                                    v-if="idv + 1 == item.data.values.length"
                                                >
                                                    <b-icon icon="plus" type="is-success" size="is-small" />
                                                </b-button>
                                            </p>
                                        </div>
                                    </b-field>
                                </div>

                                <!-- <b-field label="" custom-class="is-small">
                                    <b-input v-model="item.data." />
                                </b-field> -->
                                <hr />
                            </div>
                        </draggable>

                        <b-button @click="addEmptyItem" icon-left="plus" size="is-medium" type="is-success" class="add-btn"></b-button>
                        <has-error :form="form" field="entries" />
                    </div>

                    <div class="bottom-btns">
                        <b-button @click="$router.go(-1)" type="is-light">Cancel</b-button>
                        <b-button :loading="form.busy" native-type="submit" type="is-primary">Submit</b-button>
                    </div>
                </form>
                <b-loading :is-full-page="false" v-model="isLoading"></b-loading>
            </div>
        </div>
    </div>
</template>

<script>
import vform from "../../../plugins/vForm";
// import GalleryPicker from "../../../components/Files/GalleryPicker.vue";
// import OAuthcomplete from "../../../components/oAutocomplete.vue";
// import FiltersComponent from "../../../components/FiltersComponent.vue";
import Draggable from "vuedraggable";
export default {
    components: {
        // GalleryPicker,
        // OAuthcomplete,
        // FiltersComponent,
        Draggable,
    },
    data() {
        return {
            itemName: "Form",
            apiURI: "/forms",
            isLoading: true,
            sections: [],
            entries: [],
            form: new vform({
                id: null,
                name: "",
                entries: [],
            }),
        };
    },
    methods: {
        async init() {
            let id = this.$route.params.id;
            // Edit Loading
            if (this.isEdit) {
                // If its not Number
                if (!id || !this.isNumber(id)) {
                    this.notify("Error fetching data.", "is-danger");
                    return;
                }
                try {
                    let res = await this.$http.get(`${this.apiURI}/${id}`);
                    res.data.active = res.data.active ? 1 : 0;
                    this.form.fill(res.data);
                    this.entries = res.data.entries;
                } catch (err) {
                    this.notify(err, "is-danger");
                    return;
                }
            }
            if (this.entries.length === 0) {
                this.addEmptyItem();
            }
            this.isLoading = false;
        },
        addEmptyItem() {
            /*
text
textarea
document
image
number
email
select*/
            this.entries.push({
                id: null,
                input_type: "text",
                name_en: "",
                name_ar: "",
                name_ku: "",
                data: { values: [""] },
            });
        },
        removeItem(idx) {
            this.entries.splice(idx, 1);
            if (this.entries.length === 0) {
                this.addEmptyItem();
            }
        },
        initList(data) {
            if (!(data && data.values)) {
                data.values = [""];
            }
        },
        formSubmit() {
            this.preprocess();
            if (this.isEdit) {
                // Edit request
                this.form.password = this.form.password == "" ? undefined : this.form.password;
                let update = () => {
                    this.form
                        .submit("post", this.apiURI + "/" + this.form.id)
                        .then(() => {
                            //Alert
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: this.itemName + " editied successfully.",
                                type: "is-success",
                            });
                            this.$router.go(-1);
                            // this.$store.dispatch("loadAPI", this.$axios);
                        })
                        .catch((err) => {
                            if (err.response.status != 422) {
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: "Something went wrong.",
                                    position: "is-bottom",
                                    type: "is-danger",
                                });
                            }
                        });
                };
                if (this.form.password) {
                    // Password changed, alert for password change
                    this.$buefy.dialog.confirm({
                        title: "Changing password",
                        message: "Are you sure you want to change the <b>password</b> this user? This action cannot be undone.",
                        confirmText: "Confirm",
                        type: "is-warning",
                        hasIcon: true,
                        onConfirm: update,
                    });
                } else {
                    update();
                }
            } else {
                // before submit
                // Create request
                this.form
                    .submit("post", this.apiURI)
                    .then(() => {
                        //Alert
                        this.$buefy.toast.open({
                            duration: 5000,
                            message: this.itemName + " created successfully.",
                            type: "is-success",
                        });
                        this.$router.go(-1);
                        // this.$store.dispatch("loadAPI", this.$axios);
                    })
                    .catch((err) => {
                        if (err.response.status != 422) {
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: "Something went wrong. Please try again.",
                                position: "is-bottom",
                                type: "is-danger",
                            });
                        }
                    });
            }
        },
        preprocess() {
            this.form.entries = this.entries.map((item) => {
                const data = item.data;
                switch (item.input_type) {
                    case "text":
                    case "textarea":
                    case "number":
                        return {
                            ...item,
                            data: {
                                min: data.min ?? 0,
                                max: data.max ?? 99999999999,
                                values: [],
                            },
                        };
                    case "email":
                        return {
                            ...item,
                            data: {},
                            values: [],
                        };
                    case "select":
                        return {
                            ...item,
                            data: {
                                values: data.values,
                            },
                        };
                    case "document":
                    case "image":
                        return {
                            ...item,
                            data: {
                                multiple: data.multiple ?? 0,
                                values: [],
                            },
                        };
                    case "page_end":
                        return {
                            ...item,
                            name_en: "Page Breaker",
                            name_ar: "Page Breaker",
                            name_ku: "Page Breaker",
                            data: {
                                values: [],
                            },
                        };
                }
            });
        },
    },
    created() {},
    mounted() {
        this.init();
    },
    computed: {
        isEdit() {
            if (this.$route.path.indexOf("new") == -1) {
                return true;
            }
            return false;
        },
    },
};
</script>

<style>
.block {
    display: block;
}
.modal-form {
    position: relative;
}
img.preview-image {
    max-height: 180px;
    border-radius: 10px;
}
.flag {
    height: 20px;
    max-height: 20px;
    padding: 0px 10px;
}
.handle {
    cursor: move !important;
}
.form-entry-container .trash-btn {
    position: absolute;
    right: 0;
}
.form-entry-container .add-btn {
    height: 10px !important;
    border-radius: 0px 0px 15px 15px !important;
    margin-top: -1.5rem;
    width: 100%;
    /* height: 10px; */
}
</style>
